module.exports = __webpack_public_path__ + "static/media/InstallationCommissioningIMG.3628e136.png";